export default __webpack_public_path__ + "static/media/Simone Ruiz.8f158b78.jpg";